```vue
<template>
  <ModuleContainer v-bind="bindModule">
    <template #btn>
      <MapControlButton icon="mdi-crosshairs-gps" @click="onFlyToBbox" />
    </template>

    <slot />
  </ModuleContainer>
</template>

<script>
import ModuleMixin from '@components/Map/mixins/ModuleMixin'
import MapControlButton from '@components/Map/control/MapControlButton.vue'

export default {
  components: {
    MapControlButton,
  },

  mixins: [ModuleMixin],

  props: {
    bbox: {
      type: Array,
      required: true,

      // [minLng, minLat, maxLng, maxLat]
      validator(value) {
        return (
          value.length === 4 && value.every((item) => typeof item === 'number')
        )
      },
    },

    padding: {
      type: [Number, Object],
      default: 50,
    },

    maxZoom: {
      type: Number,
      default: 18,
    },

    duration: {
      type: Number,
      default: 1000,
    },
  },

  methods: {
    onFlyToBbox() {
      if (!this.map || !this.bbox || this.bbox.length !== 4) {
        return
      }

      const [minLng, minLat, maxLng, maxLat] = this.bbox

      this.map.fitBounds(
        [
          [minLng, minLat],
          [maxLng, maxLat],
        ],
        {
          padding: this.padding,
          maxZoom: this.maxZoom,
          duration: this.duration,
          essential: true,
        }
      )
    },
  },
}
</script>
```
